import React, {FC, PropsWithChildren, type JSX} from 'react';
import {useTrackFeature} from '../trackingHooks/useTrackFeature';
import {BaseTracker} from './BaseTracker';

export const TrackAyOutletLink: FC<
  PropsWithChildren<{
    Comp?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
    className?: string;
  }>
> = ({children, Comp = 'div', className}) => {
  const trackFeature = useTrackFeature();

  const handleTrackFeature = () => {
    return (type: 'impression' | 'click') => {
      trackFeature({eventType: type, label: 'Outlet'});
    };
  };

  return (
    <BaseTracker track={handleTrackFeature} Comp={Comp} className={className}>
      {children}
    </BaseTracker>
  );
};
